import { gql } from '@apollo/client'

export const getStudentSchedulePeriodsQuery = gql`
  query SchedulePeriods($schoolYearId: Float!, $studentId: Float!) {
    schedulePeriods(schoolYearId: $schoolYearId, studentId: $studentId) {
      CourseId
      PeriodId
      ProviderId
      ScheduleId
      SubjectId
      TitleId
      course_type
      custom_build_description
      osse_course_name
      osse_district_school
      osse_school_district_name
      schedule_period_id
      tp_additional_specific_course_website
      tp_course_name
      tp_phone_number
      tp_provider_name
      tp_specific_course_website
      status
      Schedule {
        status
        is_second_semester
        date_resubmit
        created_by_ss_script
      }
      Period {
        id
        period
      }
      Title {
        title_id
        name
        software_reimbursement
        diploma_seeking_path
        Subject {
          name
        }
      }
      Course {
        Resource {
          is_active
          resource_id
          software_reimbursement
        }
      }
    }
  }
`

export const getPeriodsForReimbursements = gql`
  query getPeriodsForReimbursements($schoolYearId: Float!, $studentId: Float!) {
    getPeriodsForReimbursements(schoolYearId: $schoolYearId, studentId: $studentId) {
      CourseId
      PeriodId
      ProviderId
      ScheduleId
      SubjectId
      TitleId
      course_type
      custom_build_description
      osse_course_name
      osse_district_school
      osse_school_district_name
      schedule_period_id
      tp_additional_specific_course_website
      tp_course_name
      tp_phone_number
      tp_provider_name
      tp_specific_course_website
      status
      Title {
        software_reimbursement
      }
      Schedule {
        status
        is_second_semester
        date_resubmit
      }
      Period {
        id
        period
      }
      Title {
        title_id
        name
        software_reimbursement
        Subject {
          name
        }
      }
      Course {
        Resource {
          is_active
          resource_id
          software_reimbursement
        }
        software_reimbursement
      }
    }
  }
`

export const getStudentSchedulePeriodHistoriesQuery = gql`
  query SchedulePeriodHistories($schoolYearId: Float!, $studentId: Float!) {
    schedulePeriodHistories(schoolYearId: $schoolYearId, studentId: $studentId) {
      CourseId
      PeriodId
      ProviderId
      ScheduleHistoryId
      SubjectId
      TitleId
      course_type
      custom_build_description
      osse_course_name
      osse_district_school
      osse_school_district_name
      schedule_period_history_id
      tp_additional_specific_course_website
      tp_course_name
      tp_phone_number
      tp_provider_name
      tp_specific_course_website
      status
      ScheduleHistory {
        schedule_history_id
        date_accepted
        is_second_semester
      }
    }
  }
`

export const getScheduleEmailsByScheduleId = gql`
  query GetScheduleEmailsByScheduleId($scheduleId: Float!) {
    getScheduleEmailsByScheduleId(scheduleId: $scheduleId) {
      body
      subject
      from_email
      created_at
    }
  }
`
